import React from 'react';
import createReactClass from 'create-react-class';
import htmr from 'htmr';
import { v4 as uuidv4 } from 'uuid';
import EventBus from './eventbus';
import '../css/ovverrides.css';
import { SchemaSkeleton } from './components/loading/schema-skeleton';
import { SmsVerification } from './components/sms-verification';
import LoadingSpinner from '../images/oval.svg';
import { EmitGoogleTagManagerEvent } from './analyticsEvents';
import { emitEvent, getCurrentVariation } from './optimizely/optimizely';
import { initSpamGuard, runPreSubmitCheck } from './services/spam-guard';

function handleOptimizely() {
  const variation = getCurrentVariation();

  if (variation === null) {
    return;
  }

  const { id, name } = variation;

  emitEvent(id, name);
}

async function applyTheme(theme) {
  const defaultTheme = 'blue';
  const chosenTheme = theme === undefined ? defaultTheme : theme;
  const getThemePath = (theme) => {
    return theme + '/' + theme + '.theme.js';
  };
  try {
    import('themes/' + getThemePath(chosenTheme));
  } catch (error) {
    import('themes/' + getThemePath(defaultTheme));
  }
}

export default function (properties) {
  const { reload, tools, language } = properties;

  const leadUuid = uuidv4();

  handleOptimizely();

  const formPoster = require('form/formPoster.jsx').default({ ...properties, leadUuid });
  const Field = require('form/field.jsx').field(properties);

  function prepareTexts(texts, state) {
    const copy = {};

    for (const key in texts) {
      copy[key] = prepareText(texts[key], state);
    }
    return copy;
  }

  let currentIndex = 0;

  function getVisiblePages() {
    const range = Array.apply(null, Array(this.props.state.pages.config.numberOfPages));
    return range.reduce((list, _, index) => {
      if (tools.getFieldsOnPage(this.props.state, index).length > 0) {
        return list.concat(index);
      } else return list;
    }, []);
  }

  function prepareText(text, state) {
    if (typeof text === 'object') {
      return Object.keys(text).reduce((firstMatch, key) => {
        if (firstMatch === null && tools.isCode(key) && tools.evaluate(key, state)) {
          return text[key];
        } else return firstMatch;
      }, null);
    } else if (tools.isCode(text)) {
      return tools.evaluate(text, state);
    } else return text;
  }

  const Leazard = createReactClass({
    leazardElement: null,

    render() {
      if (this.state.initialLoading) {
        return <SchemaSkeleton />;
      }

      const texts = prepareTexts(properties.config.texts, this.props.state);

      return (
        <div
          ref={(e) => (this.leazardElement = e)}
          className={'leazard' + (tools.isMicrosoftBrowser() ? ' lz-ie' : '')}
        >
          <div
            className={
              'leazard-loading-background' +
              (this.state.isPosting || this.state.verification.running ? ' is-visible' : '')
            }
          >
            <div
              style={{ height: '100%', width: '100%', padding: 0, margin: 0 }}
              className="leazard-loading-wrapper"
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <div style={{ marginBottom: 25 }}>
                  <LoadingSpinner style={{ transform: 'scale(1.3)' }} />
                </div>

                <div
                  style={{
                    color: '#fff',
                    fontSize: 16,
                    fontFamily: 'Open Sans,sans-serif',
                  }}
                >
                  {language['leazard-loading-text']}
                </div>
              </div>
            </div>
          </div>

          <BackgroundInfo
            texts={texts}
            isVisible={this.state.isBackgroundInfoVisible}
            toggleBackgroundInfo={this.toggleBackgroundInfo}
          />

          <Header
            texts={texts}
            showPhoneVerification={this.state.verification.smsRequired}
            showShortText={properties.config.showShortTextOnHero}
            noHover={properties.config.shortHelpTextNoHover}
            toggleBackgroundInfo={this.toggleBackgroundInfo}
          />
          <div className="lz-loading-wrapper">
            <div className="lz-loading-overlay">
              <div className="lz-loading-spinner" />
            </div>

            <Body
              {...this.props}
              showErrorsOnPage={this.state.showErrorsOnPage}
              showPhoneVerification={this.state.verification.smsRequired}
              setPhoneVerified={() => {
                this.setState({
                  verification: { ...this.state.verification, smsCompleted: true },
                });
              }}
            />

            <Footer
              texts={texts}
              state={this.props.state}
              errorFree={this.isErrorFree()}
              post={() => {
                void this.beforePost();
              }}
              phoneVerificationCompleted={this.state.verification.smsCompleted}
              showPhoneVerification={this.state.verification.smsRequired}
              showErrorsOnCurrentPage={this.showErrorsOnCurrentPage}
              pendingApiCall={this.hasPendingApi()}
              preventAnalytics={properties.config.preventAnalytics || false}
            />
          </div>
          <div id="hidden-form" />
        </div>
      );
    },

    async beforePost() {
      const { verification } = this.state;

      if (verification.smsCompleted && verification.smsRequired) {
        return this.post({
          recaptchaToken: verification.recaptchaToken,
          recaptchaScore: verification.recaptchaScore,
          smsVerified: true,
        });
      }

      this.setState({ verification: { ...verification, running: true } });

      const result = await runPreSubmitCheck({
        globalState: this.props.state.globalState,
        cachedToken: verification.recaptchaToken,
        cachedScore: verification.recaptchaScore,
      });

      this.setState({
        verification: {
          ...verification,
          recaptchaToken: result.recaptchaToken,
          recaptchaScore: result.recaptchaScore,
          smsRequired: result.requiresSmsVerification,
          running: false,
        },
      });

      if (result.requiresSmsVerification) {
        return;
      }

      this.post({
        recaptchaToken: result.recaptchaToken,
        recaptchaScore: result.recaptchaScore,
        ...(result.ranSpamCheck ? { smsVerified: false } : {}),
      });
    },

    showErrorsOnCurrentPage() {
      this.setState({
        showErrorsOnPage: this.props.state.pages.state.value,
      });
    },

    post(additionalProps) {
      if (this.state.isPosting) {
        return;
      }

      this.setState({ isPosting: true });

      formPoster(this.props.state, additionalProps);
    },

    isErrorFree() {
      const state = this.props.state;

      return !state.fields.reduce(function anyErrorsForField(bool, field) {
        if (!tools.isFieldVisible(state, field)) return bool;
        else return bool || field.state.errors.length > 0;
      }, false);
    },

    hasPendingApi() {
      const { state } = this.props;

      return !!state.fields.reduce((bool, field) => {
        if (!tools.isFieldVisible(state, field)) return bool;
        else return bool || (field.state.api.running && field.state.api.required);
      }, false);
    },

    toggleBackgroundInfo(event) {
      this.setState({
        isBackgroundInfoVisible: !this.state.isBackgroundInfoVisible,
      });
    },

    getInitialState() {
      return {
        showErrorsOnPage: -1,
        isBackgroundInfoVisible: false,
        isPosting: false,
        initialLoading: true,
        verification: {
          recaptchaToken: null,
          recaptchaScore: null,
          smsRequired: false,
          smsCompleted: false,
          running: false,
        },
      };
    },

    componentDidMount: async function () {
      if (window.iframetalker) window.iframetalker.height();

      const config = this.props.state.globalState.globalConfig;

      initSpamGuard({ recaptchaEnabled: config?.recaptchaEnabled });

      await applyTheme(config?.theme);

      setTimeout(() => {
        this.setState({ initialLoading: false });
      }, 500);
    },

    componentDidUpdate: function () {
      if (window.iframetalker) window.iframetalker.height();
    },
  });

  const Body = createReactClass({
    render() {
      const {
        showPhoneVerification,
        setPhoneVerified,
        state: { fields },
      } = this.props;

      const visibleFields = fields.filter((field) => {
        return tools.isFieldVisible(this.props.state, field);
      });

      function anyOtherFocusedTextFields(currentField, visibleFields) {
        return visibleFields.filter((field) => {
          return field !== currentField && field.state.status !== 'never-focused';
        }).length;
      }

      currentIndex = 0;

      const elements = fields.map((field, index) => {
        if (tools.isFieldOnCurrentPage(this.props.state, field)) {
          const currentPage = this.props.state.pages.state.value;
          const minPage = this.props.state.pages.config.minPage;
          const grabFocus = field === visibleFields[0] && currentPage > (minPage || 0);
          const showErrors =
            anyOtherFocusedTextFields(field, visibleFields) || (field.state.value || '').length;

          currentIndex++;

          return (
            <Field
              field={field}
              key={index}
              leadUuid={leadUuid}
              index={currentIndex}
              grabFocus={grabFocus}
              showErrors={showErrors}
              showErrorsOnPage={this.props.showErrorsOnPage}
              sharedScope={this.props.state.sharedScope}
              parsePage={tools.parsePage.bind(null, this.props.state)}
              globalState={this.props.state.globalState}
              superState={this.props.state}
            />
          );
        } else return null;
      });

      const { countryCode } = this.props.state.globalState.globalConfig;
      const { phone, phone_international_format } = this.props.state.globalState;

      return (
        <div className="leazard-body">
          <form>
            <div className="leazard-body-content">
              {showPhoneVerification && (
                <SmsVerification
                  uuid={leadUuid}
                  language={language}
                  identity="smsid.no"
                  country={countryCode}
                  phone={phone_international_format ?? phone}
                  onVerified={() => setPhoneVerified()}
                />
              )}
              {!showPhoneVerification && <> {elements}</>}
            </div>
          </form>
        </div>
      );
    },
  });

  const BackgroundInfo = createReactClass({
    componentDidMount() {
      /**
       * Subscribe to the showcustompopup event emitted by the
       * custom accept terms components used in denmark
       */
      EventBus.subscribe('showCustomPopup', (html) => {
        this.setState({
          customPopupHtml: html,
          showCustomPopup: true,
        });
      });

      /**
       * Subscribe to the event emitted by the luz.es and several other spanish sites
       * to be able to render custom html and emit data back to the active choice compoonent
       */
      EventBus.subscribe('showCustomPopupActiveChoice', ({ renderHtml, onClickHandler }) => {
        this.setState({
          showCustomPopupActiveChoice: true,
          renderHtml,
          onClickHandler,
        });
      });
    },

    getInitialState() {
      return {
        // Custom popup state
        customPopupHtml: null,
        showCustomPopup: false,

        // Active choice state
        renderHtml: false,
        showCustomPopupActiveChoice: false,
        onClickHandler: false,
      };
    },

    render() {
      const closeModal = () => {
        try {
          this.setState({
            customPopupHtml: null,
            showCustomPopup: false,
            showCustomPopupActiveChoice: false,
          });
        } catch (e) {
          console.log(e);
        }
      };

      const texts = this.props.texts;

      return (
        <div>
          <div className={'leazard-info-background' + (this.props.isVisible ? ' is-visible' : '')}>
            <div
              className="leazard-info-wrapper"
              ref={(infoElement) => (this.infoElement = infoElement)}
            >
              <div className="leazard-info">
                <div dangerouslySetInnerHTML={{ __html: texts.longHelpText }}></div>
                <a
                  className="leazard-info-btn leazard-info-hide"
                  onClick={this.props.toggleBackgroundInfo}
                >
                  {language['understood']}
                </a>
              </div>
            </div>
          </div>

          {this.state.showCustomPopupActiveChoice && (
            <div className="leazard-info-background is-visible">
              <div className="leazard-info-wrapper is-visible">
                <div className="leazard-info leazard-info-privacy">
                  <div className="leazard-info-close">
                    <div
                      onClick={() => {
                        closeModal();
                      }}
                      className="lz-icon-close"
                    ></div>
                  </div>

                  {this.state.renderHtml(this.state.onClickHandler)}

                  <a
                    onClick={() => {
                      closeModal();
                    }}
                    className="leazard-info-btn leazard-info-hide"
                  >
                    {language['close']}
                  </a>
                </div>
              </div>
            </div>
          )}

          {this.state.showCustomPopup && (
            <div className="leazard-info-background is-visible">
              <div className="leazard-info-wrapper is-visible">
                <div className="leazard-info leazard-info-privacy">
                  <div className="leazard-info-close">
                    <div
                      onClick={() => {
                        closeModal();
                      }}
                      className="lz-icon-close"
                    />
                  </div>
                  <div className="leazard-info-privacy-text">
                    {htmr(this.state.customPopupHtml)}
                  </div>
                  <a
                    onClick={() => {
                      closeModal();
                    }}
                    className="leazard-info-btn leazard-info-hide"
                  >
                    {language['close']}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    },
  });

  const Footer = createReactClass({
    render: function () {
      const {
        showPhoneVerification,
        phoneVerificationCompleted,
        texts,
        state: { pages },
      } = this.props;

      const visiblePages = getVisiblePages.bind(this)();

      const last_page_policy =
        (pages.state.value === pages.config.numberOfPages - 1 ||
          pages.state.value === visiblePages[visiblePages.length - 1]) &&
        texts.last_page_policy &&
        !showPhoneVerification;

      const policy = last_page_policy ? texts.last_page_policy.split('--x--') : '';

      const { recaptchaEnabled } = this.props.state.globalState.globalConfig;

      return (
        <div>
          {last_page_policy || texts.brukervilkår ? this.makePrivatePolicy() : null}
          <div className="leazard-cta">
            <button
              style={{
                ...(showPhoneVerification && !phoneVerificationCompleted ? { opacity: 0.4 } : {}),
              }}
              disabled={showPhoneVerification && !phoneVerificationCompleted}
              className={`leazard-btn ${!phoneVerificationCompleted ? 'lz-select-disabled' : ''}`}
              onClick={() => {
                this.gotoPage()();
              }}
            >
              {showPhoneVerification && (
                <span style={{ all: 'unset' }}>{language['leazard-two-factor-submit']}</span>
              )}
              {!showPhoneVerification && (
                <span style={{ all: 'unset' }}>{this.getButtonText()}</span>
              )}
            </button>

            {texts.bottomText ? (
              <div
                className="leazard-encrypted"
                dangerouslySetInnerHTML={{ __html: texts.bottomText }}
              />
            ) : null}

            <div className="leazard-encrypted">
              <i className="fa fa-lock"></i>
              <strong> {language['privacy-starter']} </strong>

              {last_page_policy ? (
                <div style={{ display: 'inline' }}>
                  {texts.last_page_policy_starter ? (
                    <strong>{texts.last_page_policy_starter}</strong>
                  ) : null}
                  {policy.map((snack, i) =>
                    policy.indexOf(snack) % 2 === 0 ? (
                      <div
                        key={i}
                        style={{ display: 'inline' }}
                        dangerouslySetInnerHTML={{ __html: policy[i] }}
                      />
                    ) : (
                      <a key={i} onClick={(e) => this.onClick(e, policy[i])}>
                        {' '}
                        {policy[i]}
                      </a>
                    )
                  )}
                </div>
              ) : (
                <div
                  style={{ display: 'inline' }}
                  dangerouslySetInnerHTML={{ __html: language['privacy'] }}
                />
              )}

              {recaptchaEnabled && pages.state.value === 0 && (
                <div className="leazard-encrypted">
                  <div style={{ fontSize: 10 }}>{language['recaptcha-disclaimer']}</div>
                </div>
              )}
            </div>
          </div>
          {this.makeLeazardFooter()}
        </div>
      );
    },

    makeLeazardFooter() {
      const pages = this.props.state.pages;
      const { showPhoneVerification } = this.props;

      if (pages.config.numberOfPages === 1) return null;
      else
        return (
          <div className="leazard-footer">
            <div className="lz-table lz-table-middle">
              <div className="lz-table-cell lz-cell-1-3">
                {!showPhoneVerification && (
                  <a
                    onClick={this.gotoPage(-1)}
                    className={'lz-step-back' + (pages.state.value === 0 ? ' lz-hidden' : '')}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true"></i> {language['go-back']}
                  </a>
                )}
              </div>

              {this.makePageIcons()}

              <div className="lz-table-cell lz-cell-1-3"></div>
            </div>
          </div>
        );
    },

    getInitialState() {
      return {
        showPolicy: false,
        policyToShow: '',
      };
    },

    onClick(e, data) {
      const texts = this.props.texts;
      // typeof data === "string" ? texts.indexOf(data) === -1 ?   this.setState({ policyToShow: data }) : "null";
      if (typeof data === 'string') {
        if (texts[data] === undefined) {
          this.setState({ policyToShow: 'privacy-policy' });
        } else {
          this.setState({ policyToShow: data });
        }
      } else {
        ('null');
      }

      if (!this.state.showPolicy) {
        window.scrollTo(0, 0);
      }
      this.setState((prev) => ({ showPolicy: !prev.showPolicy }));
    },

    makePrivatePolicy() {
      const texts = this.props.texts;
      const tempPolicy = texts['privacy-policy'] || language['privacy-policy'];
      const policy = tempPolicy
        .replace(/--x--/g, texts.siteName || 'denne nettsiden')
        .replace(/--y--/, texts.privacyPolicyURL || '');

      const last_page_policy_list = texts.last_page_policy.split('--x--');
      const keywords = last_page_policy_list.filter(
        (item) => last_page_policy_list.indexOf(item) % 2 !== 0
      );

      const obj1 = {};

      keywords.map((item) => {
        texts[item] === undefined
          ? (obj1['privacy-policy'] = policy)
          : (obj1[item] = texts[item] || null);
      });

      return (
        <div className={'leazard-info-background' + (this.state.showPolicy ? ' is-visible' : '')}>
          <div className={'leazard-info-wrapper' + (this.state.showPolicy ? ' is-visible' : '')}>
            <div className="leazard-info leazard-info-privacy">
              <div className="leazard-info-close" onClick={() => this.onClick()}>
                <div className="lz-icon-close"></div>
              </div>
              <div
                className="leazard-info-privacy-text"
                dangerouslySetInnerHTML={{
                  __html:
                    this.state.policyToShow !== ''
                      ? obj1[this.state.policyToShow.toString()]
                      : policy,
                }}
              ></div>
              <a className="leazard-info-btn leazard-info-hide" onClick={() => this.onClick()}>
                {language['close'] || 'LUKK'}
              </a>
            </div>
          </div>
        </div>
      );
    },

    makePageIcons() {
      const range = getVisiblePages.bind(this)();

      return (
        <div className="lz-table-cell lz-cell-1-3 lz-center">
          {range.map((index) => {
            return <div className={this.getStepClass(index)} key={index}></div>;
          })}
        </div>
      );
    },

    getButtonText() {
      const evaluateText = (text) => {
        if (tools.isCode(text)) return tools.evaluate(text, this.props.state);
        else return text;
      };

      const config = this.props.state.globalState.globalConfig;
      const pages = this.props.state.pages;
      const currentPage = pages.state.value;
      const lastPage = getVisiblePages.bind(this)().slice(-1)[0];

      const lastStepText =
        config && config.last_step_text
          ? config.last_step_text
          : evaluateText(language['last-step']);
      const nextStepText =
        config && config.next_step_text
          ? config.next_step_text
          : evaluateText(language['next-step']);

      if (this.props.pendingApiCall)
        return (
          <div className="lz-spinner">
            <i className="fa fa-spinner fa-spin"></i>
          </div>
        );
      else if (currentPage === lastPage) return lastStepText;
      else return nextStepText;
    },

    getStepClass(stepNumber) {
      const state = this.props.state.pages.state.value;
      return 'lz-step' + (stepNumber === state ? ' lz-step-current' : '');
    },

    gotoPage(increment = 1) {
      let timeoutId = null;
      return function (event) {
        if (!this.props.errorFree && increment > 0) return this.props.showErrorsOnCurrentPage();
        else if (this.props.pendingApiCall) {
          if (timeoutId) clearTimeout(timeoutId);
          timeoutId = setTimeout(this.gotoPage(increment), 100);
          return;
        }

        const pages = this.props.state.pages;

        const tempNextStep = pages.state.value + increment;
        const nextStep = tempNextStep < 0 ? pages.state.value : tempNextStep;

        if (nextStep < pages.config.numberOfPages) {
          if (getVisiblePages.bind(this)().indexOf(nextStep) === -1) {
            const nextIncrement = (Math.abs(increment) + 1) * (increment / Math.abs(increment));
            this.gotoPage(nextIncrement)();
          } else {
            if (!this.props.preventAnalytics) {
              setIntoDataLayer('page');
            }
            pages.state.value = nextStep;
            this.forceUpdate();
            reload();
          }
        } else {
          this.props.post();
        }
      }.bind(this);
    },
  });

  function setIntoDataLayer(message) {
    if (window.dataLayer !== undefined) {
      window.dataLayer.push({ event: message });
    }
  }

  const Header = createReactClass({
    render() {
      const { showPhoneVerification, noHover, showShortText, texts } = this.props;

      return (
        <div className="leazard-header">
          <p
            dangerouslySetInnerHTML={{
              __html: showPhoneVerification ? language['leazard-two-factor-header'] : texts.header,
            }}
          ></p>
          {showShortText ? (
            <span
              ref={(el) => (el ? el.style.setProperty('display', 'block', 'important') : null)}
              className="leazard-info-trigger"
              onClick={(e) => {
                this.props.toggleBackgroundInfo(e);
              }}
              dangerouslySetInnerHTML={{ __html: texts.shortHelpText }}
            />
          ) : noHover || showPhoneVerification ? (
            <span
              dangerouslySetInnerHTML={{ __html: showPhoneVerification ? '' : texts.shortHelpText }}
            />
          ) : (
            <span
              className="leazard-info-trigger"
              onClick={(e) => {
                this.props.toggleBackgroundInfo(e);
              }}
              dangerouslySetInnerHTML={{ __html: texts.shortHelpText }}
            />
          )}

          <div className="arrow bounce">
            <i className="fa fa-chevron-down fa-2x" />
          </div>
          <div className="leazard-icon">
            <span className="fa-stack fa-lg">
              <i className="fa fa-circle fa-stack-2x" aria-hidden="true" />
              <i className="fa fa-check fa-stack-1x fa-inverse" aria-hidden="true" />
            </span>
          </div>
        </div>
      );
    },
  });

  return Leazard;
}
